import { useEffect, useState } from "react";

import { getStatsSummary, StatsPeriodFilter } from "services/stats/rest";
import { StatsSummaryDto } from "services/stats/restModels";

export interface UseStatsSummaryResult {
    summary: StatsSummaryDto | null;
    loading: boolean;
    error: boolean;
}

/*
* Итоги периода вместе с итогами периода сравнения — одним запросом. Окно сравнения считает
* вызывающий (см. shared/lib/statsPeriods): оно зависит от выбранного пресета, а не от длины.
* */
export const useStatsSummary = (
    filter: StatsPeriodFilter | null,
    compare: StatsPeriodFilter | null
): UseStatsSummaryResult => {
    const [summary, setSummary] = useState<StatsSummaryDto | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    // Поля фильтра — отдельными переменными: объект пересобирается на каждый рендер
    // вызывающего, и в зависимостях эффекта он гнал бы запрос по кругу.
    const menuId = filter === null ? null : filter.menuId;
    const from = filter === null ? null : filter.from;
    const to = filter === null ? null : filter.to;
    const compareFrom = compare === null ? null : compare.from;
    const compareTo = compare === null ? null : compare.to;

    useEffect(() => {
        // Меню не выбрано — запрос бессмыслен. Загрузку снимаем: у филиала может не быть ни
        // одного меню, и экран должен показать пустое состояние, а не спиннер.
        if (menuId === null || from === null || to === null) {
            setSummary(null);
            setLoading(false);
            return undefined;
        }

        // ignore-флаг: ответ по прошлому периоду не трогает стейт.
        let ignore = false;

        setLoading(true);
        setError(false);

        getStatsSummary(
            { menuId, from, to },
            compareFrom === null || compareTo === null
                ? null
                : { menuId, from: compareFrom, to: compareTo }
        )
            .then((result) => {
                if (ignore) return;
                if (result) {
                    setSummary(result);
                } else {
                    setError(true);
                    setSummary(null);
                }
            })
            .catch(() => {
                if (ignore) return;
                setError(true);
                setSummary(null);
            })
            .finally(() => {
                if (ignore) return;
                setLoading(false);
            });

        return () => {
            ignore = true;
        };
    }, [menuId, from, to, compareFrom, compareTo]);

    return { summary, loading, error };
};
